module.exports = __webpack_public_path__ + "static/media/twoGoExpress.381de99f.png";